// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
// import { faMoneyBill } from '@fortawesome/pro-solid-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);